import { createTheme } from '@shopify/restyle'

import { buildFunkitTheme } from './buildFunkitTheme'
import { type FunkitTokens, darkTokens, lightTokens } from './tokens'

/**
 * Wraps the pure {@link buildFunkitTheme} projection in Restyle's `createTheme`.
 * All the real work — mirroring the Fun Variables Figma groups onto the theme —
 * lives in `buildFunkitTheme`; this is just the thin Restyle boundary so the
 * projection stays testable without Restyle's react-native imports.
 */
export function toRestyleTheme(tokens: FunkitTokens) {
  return createTheme(buildFunkitTheme(tokens))
}

/** The Restyle theme type all connect-rn components are written against. */
export type FunkitTheme = ReturnType<typeof toRestyleTheme>

/** Built-in default Restyle themes derived from the Fun Variables Light/Dark tokens. */
export const defaultLightTheme = toRestyleTheme(lightTokens)
export const defaultDarkTheme = toRestyleTheme(darkTokens)
